import { Badge, Icon } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { MinimumRequirementResponseType } from "../../../../../autogen/bff-api";
import { MINIMUM_REQUIREMENT_RESPONSE_TYPE_OPTIONS } from "../utils/publicProcurementOptions";

interface Props {
  responseType: MinimumRequirementResponseType;
}

export const MinimumRequirementResponseTypeBadge = ({ responseType }: Props) => {
  const { t } = useTranslation();
  const option = MINIMUM_REQUIREMENT_RESPONSE_TYPE_OPTIONS.find((o) => o.value === responseType);
  if (!option) return null;

  return (
    <Badge
      display="inline-flex"
      alignItems="center"
      gap="1.5"
      bg={option.badgeBg}
      color={option.badgeColor}
      px="2.5"
      py="1"
      borderRadius="md"
      fontWeight="medium"
      fontSize="xs"
      textTransform="none"
    >
      <Icon as={option.icon} />
      {t(option.labelKey)}
    </Badge>
  );
};
